import { useEffect } from 'react';

const useOutsideClick = (ref, targetRef, callback) => {
  const handleClick = (event) => {
    const element = ref.current;

    if (!element) return;

    // Internet Explorer loves SVG's, but it doesn't really support the same things
    // on them as we would like. To instead of `.contains` we need to use the `compareDocumentPosition`
    // method in IE. The poptip `element` can be an SVG so we will use it here. The 16 comes from
    // `Node.DOCUMENT_POSITION_CONTAINED_BY` but just to be sure with older browsers we hardcode it.
    const elementContainsTarget = element.contains
      ? element.contains(event.target)
      : element.compareDocumentPosition
      ? Boolean(element.compareDocumentPosition(event.target) & 16)
      : true;

    if (
      !elementContainsTarget &&
      !element.contains(event.target) &&
      !targetRef.current.contains(event.target)
    ) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('blur', handleClick, true);
    document.addEventListener('click', handleClick, false);

    return () => {
      // unsubscribe event
      document.removeEventListener('blur', handleClick);
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
